// extracted by mini-css-extract-plugin
export default {"container":"styles_container__xVcn5","reqSymbol":"styles_reqSymbol__KzLGs"};